import { getCache as e, KnownDomain as o } from "@ado/client-side-caching";
const a = "The context must be defined";
class h {
  constructor(t, c) {
    this.cacheName = t, this.defaultContent = c;
  }
  context;
  switchContext(t) {
    this.context = t;
  }
  get() {
    const t = this.createCacheKey();
    return e().getItem(t) ?? this.defaultContent;
  }
  set(t) {
    const c = this.createCacheKey();
    e().setItem(c, t);
  }
  reset() {
    const t = e().createKey(
      o.Foundation,
      this.cacheName
    );
    e().removeAllItemsWithKeyContainingString(t);
  }
  createCacheKey() {
    if (this.context === void 0)
      throw new Error(a);
    const t = Object.values(this.context).sort();
    return e().createKey(
      o.Foundation,
      this.cacheName,
      ...t
    );
  }
}
export {
  h as LocalStorageState
};
//# sourceMappingURL=index3.js.map
